import { render, staticRenderFns } from "./NoticeToCustomers.vue?vue&type=template&id=9886a4ae&"
import script from "./NoticeToCustomers.vue?vue&type=script&lang=js&"
export * from "./NoticeToCustomers.vue?vue&type=script&lang=js&"
import style0 from "./NoticeToCustomers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports